import React, { useState } from 'react';
import { supabase } from '../lib/supabase';
import Step1Lookup from '../components/dashboard/Step1Lookup';
import Step2Choice from '../components/dashboard/Step2Choice';
import Step2bTradeIn from '../components/dashboard/Step2bTradeIn';
import Step2cLoanInfo from '../components/dashboard/Step2cLoanInfo';
import Step3Loading from '../components/dashboard/Step3Loading';
import Step4Success from '../components/dashboard/Step4Success';
import Step5Handoff from '../components/dashboard/Step5Handoff';

const TOTAL_STEPS = 6;

export default function Dashboard() {
  const [step, setStep] = useState(1);
  const [debtDetails, setDebtDetails] = useState({ carrier: '', amount: '' });
  const [choice, setChoice] = useState('');
  const [tradeDetails, setTradeDetails] = useState(null);

  const logToSupabase = async (table, data) => {
    try {
      const { data: { user } } = await supabase.auth.getUser();
      if (user) await supabase.from(table).insert([{ user_id: user.id, ...data }]);
    } catch (e) {
      console.log('Supabase insert skipped.');
    }
  };

  const handleStep1Submit = (details) => {
    setDebtDetails(details);
    logToSupabase('debt_profiles_1716163200', {
      current_carrier: details.carrier,
      debt_amount: parseFloat(details.amount),
      device_model: 'Unknown',
    });
    setStep(2);
  };

  const handleStep2Choice = (selectedChoice) => {
    setChoice(selectedChoice);
    // 'trade' → step 2b (trade-in form), 'keep' → step 2c (loan info)
    setStep(selectedChoice === 'trade' ? 2.5 : 2.8);
  };

  const handleTradeInSubmit = (details) => {
    setTradeDetails(details);
    setStep(3);
  };

  const handleLoanInfoSubmit = (info) => {
    logToSupabase('applications_1716163200', { flow_type: 'loan', status: 'processing' });
    setStep(3);
  };

  const handleStep3Complete = () => setStep(4);

  const handleStep4Accept = () => {
    logToSupabase('applications_1716163200', { flow_type: choice, status: 'approved', partner_link_clicked: true });
    setStep(5);
  };

  // Map internal step to visual progress (1–6)
  const visualStep = step === 2.5 || step === 2.8 ? 3 : step >= 3 ? step + 1 : step;

  return (
    <div className="min-h-[calc(100vh-80px)] bg-slate-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto">
        <div className="mb-8 flex justify-center space-x-2">
          {[1, 2, 3, 4, 5, 6].map((s) => (
            <div key={s}
              className={`h-2 w-12 rounded-full transition-colors duration-300 ${s <= visualStep ? 'bg-blue-600' : 'bg-slate-200'}`}
            />
          ))}
        </div>

        {step === 1 && <Step1Lookup onSubmit={handleStep1Submit} />}
        {step === 2 && <Step2Choice onSelect={handleStep2Choice} amount={debtDetails.amount} />}
        {step === 2.5 && <Step2bTradeIn onSubmit={handleTradeInSubmit} />}
        {step === 2.8 && <Step2cLoanInfo onSubmit={handleLoanInfoSubmit} amount={debtDetails.amount} />}
        {step === 3 && <Step3Loading onComplete={handleStep3Complete} />}
        {step === 4 && (
          <Step4Success
            onAccept={handleStep4Accept}
            amount={debtDetails.amount}
            choice={choice}
            tradeDetails={tradeDetails}
          />
        )}
        {step === 5 && <Step5Handoff />}
      </div>
    </div>
  );
}